import localRequest from './LocalServer/localRequest';

export const setVariable = async () => {
  await new Promise(async (resolve, reject) => {
    await localRequest({
      method: 'get',
      url: `/env`,
    }).then((res) => {
      console.log(res.data);
      localStorage.setItem('ISLOCAL', res.data?.REACT_APP_ISLOCAL);
      localStorage.setItem('INI_TIME', res.data?.REACT_APP_INI_TIME);
      localStorage.setItem('MSC', res.data?.REACT_APP_MSC);
      localStorage.setItem('BARCODE', res.data?.REACT_APP_BARCODE);
      localStorage.setItem('DAILYBLEND', res.data?.REACT_APP_DAILYBLEND);
      localStorage.setItem('MSC_API', res.data?.REACT_APP_MSC_API);
      localStorage.setItem('MSC_USER', res.data?.REACT_APP_MSC_USER);
      localStorage.setItem('MSC_PASS', res.data?.REACT_APP_MSC_PASS);
      localStorage.setItem('MSC_EXCODE', res.data?.REACT_APP_MSC_EXCODE);
      localStorage.setItem('MSC_MAC', res.data?.REACT_APP_MSC_MAC);
      localStorage.setItem('HIDE_PROMO', res.data?.REACT_APP_HIDE_PROMO);
      localStorage.setItem('HIDE_CARDS', res.data?.REACT_APP_HIDE_CARDS);
      localStorage.setItem('LOGOUT', res.data?.REACT_APP_LOGOUT);
      localStorage.setItem('SKIP_PAYMENT', res.data?.REACT_APP_SKIP_PAYMENT);
      localStorage.setItem('HIDE_TAX', res.data?.REACT_APP_HIDE_TAX);
      localStorage.setItem('send_order_third', res.data?.REACT_APP_SEND_ORDER_THIRD);
      resolve(0);
    });
  });
};
